<script>
    import BaseTableLayoutProps from "../../BaseTableLayoutProps";
    import {FORM_TABLE_THEME} from "../../../form-table-theme";

    export default {
        name: "ComponentTablePropsMixin",
        mixins: [BaseTableLayoutProps],
        props: {
            provider: {type: String, default: FORM_TABLE_THEME.DEFAULT},
            search: {
                type: String,
                default: undefined,
            },
            /** true 이면 sort 시 desc 로 먼저 sorting 합니다. */
            sortDesc: {
                type: Boolean,
                default: true,
            },
        },
    }
</script>